import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDeviceStore = defineStore('device', () => {
    const isMobile = ref(false);

    const detectDevice = () => {
        const ua = navigator.userAgent;
        isMobile.value =
            /Android|iPhone|iPad|iPod|Mobile/i.test(ua) ||
            window.innerWidth <= 1024;
    };

    const init = () => {
        detectDevice();
        window.addEventListener('resize', detectDevice);
    };

    return {
        isMobile,
        init
    };
});